var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaldare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26.6,
    stroke: "#E5E5E5",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M1.4 28C1.4 42.6908 13.3092 54.6 28 54.6C42.6908 54.6 54.6 42.6908 54.6 28C54.6 13.3093 42.6908 1.40002 28 1.40002",
    stroke: "#DB0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9114 24.2269C35.4717 24.5891 33.7718 24.6131 32.3035 24.1646C31.6828 23.9749 31.1988 23.4914 30.9893 22.8771C30.4674 21.3468 30.3385 19.4736 30.722 18.0318C29.9279 18.0119 29.0248 18 28 18C24.5157 18 22.4394 18.1368 21.2628 18.2638C20.3912 18.3578 19.719 18.9483 19.5558 19.8097C19.3017 21.1505 19 23.6572 19 28C19 32.3428 19.3017 34.8494 19.5558 36.1903C19.719 37.0518 20.3912 37.6422 21.2628 37.7362C22.4394 37.8631 24.5157 38 28 38C31.4843 38 33.5606 37.8631 34.7372 37.7362C35.6089 37.6422 36.281 37.0518 36.4442 36.1903C36.6982 34.8494 37 32.3428 37 28C37 26.5445 36.9661 25.2952 36.9114 24.2269Z",
    fill: "#DB0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9115 24.2269C35.4717 24.5891 33.7718 24.6131 32.3036 24.1646C31.6828 23.9749 31.1988 23.4914 30.9893 22.8771C30.4674 21.3467 30.3385 19.4736 30.7221 18.0317C30.7221 18.0317 31.9462 18.4999 34.1962 20.7499C36.4462 22.9999 36.9115 24.2269 36.9115 24.2269Z",
    fill: "#DB0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaldare);
export default __webpack_public_path__ + "static/media/saldare.bd8250533e5b0e1b414111b2b4065604.svg";
export { ForwardRef as ReactComponent };